import { NOMINEEINFO } from './update-nominee-edit';

export const recalculateShares = (nomineesData: NOMINEEINFO[]): NOMINEEINFO[] => {
    if (!nomineesData || nomineesData.length === 0) return [];

    const touchedIndices: number[] = [];
    const untouchedIndices: number[] = [];
    let touchedSum = 0;

    nomineesData?.forEach((nom, idx) => {
        if (!nom) return;
        if (nom.isShareTouched) {
            touchedIndices.push(idx);
            if (nom.share !== null && nom.share !== undefined) {
                const shareNum = Number(nom.share);
                touchedSum += isNaN(shareNum) ? 0 : shareNum;
            }
        } else {
            untouchedIndices.push(idx);
        }
    });

    const remaining = Math.max(0, 100 - touchedSum);
    const untouchedCount = untouchedIndices.length;

    if (untouchedCount === 0) {
        return nomineesData;
    }

    if (remaining <= 0) {
        return nomineesData?.map((nom, idx) => {
            if (untouchedIndices.includes(idx)) {
                return { ...nom, share: 0 };
            }
            return nom;
        });
    }

    const baseShare = Math.floor(remaining / untouchedCount);
    const remainder = remaining - baseShare * untouchedCount;
    const firstUntouchedIdx = untouchedIndices[0];

    return nomineesData?.map((nom, idx) => {
        if (untouchedIndices.includes(idx)) {
            const share = idx === firstUntouchedIdx ? baseShare + remainder : baseShare;
            return { ...nom, share };
        }
        return nom;
    });
};

export const handleShareChangeLogic = (
    newValue: string,
    index: number,
    currentNominees: NOMINEEINFO[],
): NOMINEEINFO[] => {
    if (!currentNominees || index < 0 || index >= currentNominees.length) {
        return currentNominees || [];
    }

    const updatedNominees = [...currentNominees];
    const isClearing = newValue === '' || (newValue && newValue.trim() === '');

    if (isClearing) {
        updatedNominees[index] = {
            ...updatedNominees[index],
            share: null,
            isShareTouched: true,
            isEdited: true,
        };
    } else {
        const numValue = Number(newValue);
        updatedNominees[index] = {
            ...updatedNominees[index],
            share: isNaN(numValue) ? 0 : numValue,
            isShareTouched: true,
            isEdited: true,
        };
    }

    return recalculateShares(updatedNominees);
};

export const handleShareBlurLogic = (
    index: number,
    currentNominees: NOMINEEINFO[],
): NOMINEEINFO[] | null => {
    if (!currentNominees || index < 0 || index >= currentNominees.length) {
        return null;
    }

    const nominee = currentNominees[index];
    if (!nominee) return null;

    if (nominee.share === null || nominee.share === undefined || nominee.share === 0) {
        const updatedNominees = [...currentNominees];
        updatedNominees[index] = {
            ...updatedNominees[index],
            share: null,
            isShareTouched: false,
            isEdited: true,
        };
        return recalculateShares(updatedNominees);
    }
    return null;
};
